import { CustomParseFieldProps } from "@opendash/plugin-parse/src/types";
import { Button, Drawer, Tooltip } from "antd";
import React from "react";

import { useOpenDashServices } from "@opendash/core";
import {
  DataItemDimensionIdentifierInterface,
  DataSelect,
  useDataService,
} from "@opendash/plugin-timeseries";

const CustomParseSingleDimensionSelector = (
  val: CustomParseFieldProps<any>
) => {
  const [open, setOpen] = React.useState(false);
  const DataService = useDataService();
  const { SourceService } = useOpenDashServices();
  let name = "Datenquelle wechseln";
  let btnAction = () => {
    setOpen(true);
  };
  try {
    name = DataService.getItemName(
      DataService._getOrThrowSync(val.value[0], val.value[1]),
      val.value[2],
      false
    );
  } catch (e) {
    console.log({ val });
    if (!val.value || val.value.length === 0) {
      name = "Quelle festlegen";
    } else {
      btnAction = () => {
        const source = SourceService.getAll().find(
          (s) => s.tag === val.value[0]
        );
        SourceService.setCurrent(source.id);
      };
    }
  }

  return (
    <>
      <Tooltip title={name}>
        <Button type="default" onClick={btnAction}>
          {name.substring(0, 10) + "..."}
        </Button>
      </Tooltip>
      <Drawer
        open={open}
        placement="bottom"
        height={"75%"}
        onClose={() => {
          setOpen(false);
        }}
      >
        <DataSelect
          selectionOptions={{
            max: 1,
            min: 1,
            types: ["Geo"],
            select: "dimension",
          }}
          selection={[val.value as DataItemDimensionIdentifierInterface]}
          onSelection={(selection) => {
            //val.setValue(selection[0]);
            val.parseObject.set("allVehicles", selection[0]);
            val.parseObject.save().then((res) => {
              if (res != null) {
                setOpen(false);
              }
            });
          }}
        />
      </Drawer>
    </>
  );
};
export default CustomParseSingleDimensionSelector;
